module.exports = __webpack_public_path__ + "img/ImageStefan.5eccd5fd.jpg";